import React from 'react'
import PropTypes from 'prop-types'
import { Icon, List } from 'semantic-ui-react'
import IntelMsg from '../../ItelMsg'

const ListItem = ({ imageSrc, title, onClick }) => (
  <List.Item
    style={{ cursor: 'pointer', margin: 'auto', display: 'inline-block' }}
    onClick={(e) => onClick(e)}
  >
    <Icon size="large" name={imageSrc} />
    <List.Content>
      <List.Header>{title || <IntelMsg id="spectro" />}</List.Header>
    </List.Content>
  </List.Item>
)

ListItem.propTypes = {
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}

export default ListItem
